export default "__VITE_ASSET__b54cd6f8__"